/* calculate pixels */
@function calc-px($value-in-px) {
    @return calc($value-in-px / 584 * var(--slide-width) * 1px);
}

:host {
    background-color: $color-grey-01-dark;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 100%;
    z-index: 1;
    top: 0;
    left: 0;
}

:host(.--active) {
    opacity: 1;
    z-index: 2;

    .line-top,
    .line-bottom {
        background-color: $color-white;
        width: 100%;
    }

    .value,
    .description {
        color: $color-white;
    }

    .line-top,
    .line-bottom,
    .value,
    .description {
        margin-left: calc-px(60);
        position: relative;
        top: 100%;
    }

    .line-top {
        animation: sliderAnimation 3s forwards ease-in-out;
        height: calc-px(5);
    }

    .value {
        display: flex;
        font-family: 'Helvetica Now Text Bold', sans-serif;
        font-size: calc-px(120);
        height: 100%;
        justify-content: flex-end;
        right: calc-px(78);
        line-height: calc-px(120);
        top: 0;
        margin-left: 0;
        position: absolute;
        width: 100%;

        span {
            animation: sliderAnimation 3s 0.3s forwards ease-in-out;
            margin-top: calc-px(88);
            position: relative;
            top: 100%;

            &:nth-child(1) {
                animation-delay: 0.3s;
            }

            &:nth-child(2) {
                animation-delay: 0.35s;
            }

            &:nth-child(3) {
                animation-delay: 0.4s;
            }

            &:nth-child(4) {
                animation-delay: 0.45s;
            }

            &:nth-child(5) {
                animation-delay: 0.5s;
            }

            &:nth-child(6) {
                animation-delay: 0.55s;
            }

            &:nth-child(7) {
                animation-delay: 0.6s;
            }

            &:nth-child(8) {
                animation-delay: 0.65s;
            }

            &:nth-child(9) {
                animation-delay: 0.7s;
            }
        }
    }

    .description {
        font-family: 'Helvetica Now Text Medium', sans-serif;
        animation: sliderAnimation 3s 0.6s forwards ease-in-out;
        display: flex;
        flex-direction: column;
        font-size: calc-px(22);
        line-height: calc-px(40);
        margin-top: calc-px(24);
        padding-right: calc-px(84);
        text-align: right;

        &::before {
            content: '123';
            font-size: calc-px(120);
            line-height: calc-px(120);
            opacity: 0;
        }
    }

    .line-bottom {
        animation: sliderAnimation 3s 0.9s forwards ease-in-out;
        height: 1px;
        margin-top: calc-px(40);
    }
}

@keyframes sliderAnimation {
    0% {
        opacity: 0;
        top: 100%;
    }

    25% {
        opacity: 1;
        top: 0;
    }

    75% {
        opacity: 1;
        top: 0;
    }

    100% {
        opacity: 0;
        top: -100%;
    }
}

@keyframes sliderAnimationTopContent {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
        transform: translateY(-100px);
    }
}
